exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title{font-size:40px;margin-bottom:40px}.error{color:red}.btn-info{border-radius:56px;min-width:150px;min-height:50px;font-size:18px;-webkit-box-shadow:5px 5px 5px 0 rgba(0,0,0,.75);-moz-box-shadow:5px 5px 5px 0 rgba(0,0,0,.75);box-shadow:5px 5px 5px 0 rgba(0,0,0,.75)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-80e43150","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Results/CprResultsView.vue
// module id = 315
// module chunks = 0